<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            <router-link
                v-if="linked"
                div="span"
                :to="{ name: 'ven-cockpit-chart', params: { tipo: datacontent.titulo } }"
            >
                {{ title }}
            </router-link>
            <div v-else>{{ title }}</div>
            <div style="display: inline-block; cursor: pointer; padding-right: 4px">
                <span class="zoom-icon" v-tippy :title="$t('zoom-close')">
                    <svg class="svg-icons" @click="closeZoom()" v-if="zoomned && hasZoom">
                        <use
                            :xlink:href="require('@/assets/img/icons/zoom-close.svg') + '#layer'"
                        ></use>
                    </svg>
                </span>

                <span 
                    class="zoom-icon" 
                    v-tippy 
                    :title="!zoomned ? $t('zoom-in') : $t('zoom-out')"
                >
                    <svg class="svg-icons" @click="zoom()">
                        <use
                            v-if="!zoomned"
                            :xlink:href="require('@/assets/img/icons/zoom-in.svg') + '#layer'"
                        ></use>
                        <use
                            v-else
                            :xlink:href="require('@/assets/img/icons/zoom-out.svg') + '#layer'"
                        ></use>
                    </svg>
                </span>
                <div 
                    v-if="info != null" 
                    style="display: inline-block; cursor: pointer; margin-left: 10px"
                >
                    <b-icon icon="information" v-tippy :title="getT(info)" />
                </div>
            </div>
        </div>
        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content" v-if="!noData && !loading">
            <svg class="chart_v" ref="svgcontent"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData && !loading">
            <div ref="LGbox" class="legend-chart"></div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="noData && !loading">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="loading">
            <svg class="loading">
                <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('carregando') }}...</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import CockpitVendasService from '@/services/CockpitVendasService';
import CockpitDespesasService from '@/services/CockpitDespesasService';
import CockpitAgroService from '@/services/agro/cockpit/CockpitAgroService';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: {
        title: {
            type: String,
            default: '',
        },
        datacontent: {
            type: Object,
            default: () => {
                return {};
            },
        },
        filtro: {
            type: Object,
            default: () => {
                return {};
            },
        },
        direction: {
            type: String,
            default: 'v',
        },
        linked: {
            type: Boolean,
            default: false,
        },
        module: {
            type: String,
            default: 'VENDAS', // vendas, despesas, promotor
        },
        info: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            cores: [],
            cores2: [],
            datacaption: {},
            filtered: [],
            filteredZoom: [],
            service: null,
            tooltipDiv: null,
            formatter: new Intl.NumberFormat(),
            loading: true,
            zoomned: false,
            hasZoom: false,
            decimalOpts: {
                minimumFractionDigits: this.getValorDP(),
                maximumFractionDigits: this.getValorDP(),
            },
        };
    },
    created() {
        // this.filtro.empresas = []
        // this.filtro.vendedores = []
        if (this.module == 'DESPESAS') {
            this.service = new CockpitDespesasService(this.$http, this.$router);
        } else if (this.module == 'AGRO') {
            this.service = new CockpitAgroService(this.$http, this.$router);
        } else {
            this.service = new CockpitVendasService(this.$http, this.$router);
        }
        this.cores = paleta.getBarColors();
        this.cores2 = paleta.getAbcColor();

        if (!this.noData) {
            setTimeout(() => {
                this.mountChart();
                this.loading = false;
            }, 50);
        } else {
            this.loadData();
        }
    },
    computed: {
        noData() {
            return (
                !this.datacontent || !this.datacontent.items || this.datacontent.items.length == 0
            );
        },
        dataset() {
            if (this.datacontent && this.datacontent.items && this.datacontent.items.length > 0) {
                let items = this.datacontent.items;
                items[0].values = items[0].values.filter((e) => e.value > 0);

                return items;
            } else {
                return [];
            }
        },
    },
    watch: {
        /* Se houver modificação no datacontent, ele redesenha o gráfico. */
        datacontent: {
            deep: true,
            handler(nc) {
                if (nc.items) {
                    this.redrawChart();
                }
            },
        },
    },
    methods: {
        loadData() {
            this.loading = true;
            this.service
                .getChartByTitulo(this.datacontent.titulo, this.filtro)
                .then((r) => {
                    if (r) {
                        this.$emit('update-content', r);
                    } else {
                        console.warn(`Card vazio: ${this.datacontent.titulo}`);
                    }
                })
                .catch((e) => {
                })
                .finally((_) => {
                    this.loading = false;
                });
        },
        svgChart() {
            var d3 = this.$d3;

            let brushed = () => {
                this.hasZoom = true;
                let extent = d3.event.selection;
                var selected = null;
                if (extent) {
                    let domainSize = x2.domain().length;
                    selected = x2.domain().filter(function (d, index) {
                        let fim = x2(x2.domain()[index + 1]) - 15;
                        if (index < domainSize - 1) {
                            return extent[0] <= fim && x2(d) <= extent[1];
                        } else {
                            return extent[0] <= width && x2(d) <= extent[1];
                        }
                    });
                }

                var start;
                var end;

                if (extent && extent[0] != extent[1]) {
                    start = selected[0];
                    end = selected[selected.length - 1];
                    start = this.dataset[0].values.indexOf(
                        this.dataset[0].values.filter((v) => v.name == start)[0]
                    );
                    end =
                        this.dataset[0].values.indexOf(
                            this.dataset[0].values.filter((v) => v.name == end)[0]
                        ) + 1;
                } else {
                    start = 0;
                    end = this.dataset[0].values.length;
                }

                var updatedData = this.dataset[0].values.slice(start, end);

                if (selected) {
                    this.filtered = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) == -1);
                    this.filteredZoom = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) > -1);
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                } else {
                    this.filtered = [];
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                }

                update(updatedData);
                enter(updatedData);
                exit(updatedData);
                updateScale(updatedData);
            };

            let updateScale = function (data) {
                var tickScale = d3
                    .scalePow()
                    .range([data.length / 10, 0])
                    .domain([data.length, 0])
                    .exponent(0.5);

                var brushValue = brush.extent()[1] - brush.extent()[0];
                if (brushValue === 0) {
                    brushValue = width;
                }

                var tickValueMultiplier = Math.ceil(Math.abs(tickScale(brushValue)));
                var filteredTickValues = data
                    .filter(function (d, i) {
                        return i % tickValueMultiplier === 0;
                    })
                    .map(function (d) {
                        return d.date;
                    });

                focus.select('.x.axis').call(xAxis.tickValues(filteredTickValues));
                focus.select('.y.axis').call(yAxis);
            };

            let update = (data) => {
                this.data = data;
                x.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                var bars = focus.selectAll('.bar').data(data);

                bars.attr('height', function (d) {
                    return height - y(d.value);
                })
                    .attr('width', function (d, i) {
                        return x.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x(d.name);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', function (d) {
                        return color(d.name);
                    });
            };

            let exit = function (data) {
                var bars = focus.selectAll('.bar').data(data);
                bars.exit().remove();
            };

            let enter = (data) => {
                this.data = data;
                x.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                this.$d3
                    .selectAll('.selection')
                    .attr('height', '77px')
                    .attr('stroke', this.cores[0]);

                this.tooltipDiv.remove();

                this.tooltipDiv = this.$d3
                    .select('body')
                    .append('div')
                    .attr('class', 'chart-tooltip')
                    .style('opacity', 0);

                var bars = focus.selectAll('.bar').data(data);

                bars.enter()
                    .append('rect')
                    .classed('bar', true)
                    .attr('height', function (d) {
                        return height - y(d.value);
                    })
                    .attr('width', function (d) {
                        return x.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x(d.name);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', function (d) {
                        return color(d.name);
                    })
                    .on('mouseover', this.tooltipMouseoverEvt)
                    .on('mousemove', (d) => {
                        this.tooltipDiv
                            .style(
                                'left',
                                this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                            )
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        this.tooltipDiv.transition().duration(500).style('opacity', 0);
                    });
            };

            var margin = { top: 10, right: 10, bottom: 120, left: 40 },
                margin2 = {
                    top: this.$refs.chartContent.offsetHeight - 90,
                    right: 10,
                    bottom: 40,
                    left: 40,
                };
            var width = this.$refs.chartContent.offsetWidth - margin.left - margin.right;
            var height = this.$refs.chartContent.offsetHeight - margin.top - margin.bottom;
            var height2 = this.$refs.chartContent.offsetHeight - margin2.top - margin2.bottom;
            // var h = height - margin.top - margin.bottom;

            var x = this.$d3.scaleBand().range([0, width]).padding(0.1),
                x2 = this.$d3.scaleBand().range([0, width]).padding(0.1),
                y = this.$d3.scaleLinear().range([height, 0]),
                y2 = this.$d3.scaleLinear().range([height2, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);

            var xAxis = this.$d3.axisBottom(x),
                xAxis2 = this.$d3.axisBottom(x).tickValues([]),
                yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            // var rowgroup = this.dataset.map(function(d) { return d.name })
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            x.domain(colNames).range([0, width]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);
            x2.domain(x.domain());
            y2.domain(y.domain());

            var brush = d3
                .brushX()
                .extent([
                    [0, 0],
                    [width, height],
                ])
                .on('brush', brushed)
                .on('start', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('height', '77px')
                        .attr('stroke', this.cores[0]);
                    brushed();
                })
                .on('end', () => {
                    let extent = d3.event.selection;
                    if (!extent) {
                        this.closeZoom();
                    }
                });

            var svg = this.$d3.select(this.$refs.svgcontent);

            var focus = svg
                .append('g')
                .attr('class', 'focus')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var context = svg
                .append('g')
                .attr('class', 'context')
                .attr('transform', 'translate(' + margin2.left + ',' + margin2.top + ')');

            focus
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis);

            focus.append('g').attr('class', 'y axis').call(yAxis);

            enter(this.dataset[0].values);
            updateScale(this.dataset[0].values);

            var subBars = context.selectAll('.subBar').data(this.dataset[0].values);

            subBars
                .enter()
                .append('rect')
                .classed('subBar', true)
                .attr('height', function (d) {
                    return height2 - y2(d.value);
                })
                .attr('width', function (d, i) {
                    return x.bandwidth();
                })
                .attr('x', function (d) {
                    return x2(d.name);
                })
                .attr('y', function (d) {
                    return y2(d.value);
                })
                .attr('fill', function (d) {
                    return '#c6c6c6';
                });

            context
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height2 + ')')
                .call(xAxis2);

            context
                .append('g')
                .attr('class', 'x brush')
                .call(brush)
                .on('click', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('height', '77px')
                        .attr('stroke', this.cores[0]);
                })
                .selectAll('rect')
                .attr('y', -6)
                .attr('height', height2 + 7);

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    // if (!this.hasZoom) {
                    let filtered = [...this.filtered];
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) {
                            if (!this.hasZoom) {
                                this.filtered = [];
                            } else {
                                this.filtered = filtered;
                            }
                        }
                    }
                    // otherwise remove it:
                    else {
                        // if (!this.hasZoom) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // } else if (this.filteredZoom.indexOf(d) > -1) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // }
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    // }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    if (newKeys.length == 0) {
                        if (!this.hasZoom) {
                            color.domain().forEach((d1) => {
                                if (this.filtered.indexOf(d1) == -1 && d) {
                                    newKeys.push(d1);
                                }
                            });
                        } else {
                            this.filteredZoom.forEach((d2) => {
                                if (this.filtered.indexOf(d2) == -1 && d2) {
                                    newKeys.push(d2);
                                }
                            });
                        }
                    }

                    x.domain(newKeys).range([0, width]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d4, key) => {
                                if (this.hasZoom) {
                                    if (this.filteredZoom.indexOf(d4.name) > -1) return d4.value;
                                } else {
                                    if (this.filtered.indexOf(d4.name) == -1) return d4.value;
                                }
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    // let d3 = this.$d3;

                    let bars = focus.selectAll('.bar').data(this.data);

                    bars.filter((d5) => {
                        return this.filtered.indexOf(d5.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d5) {
                            return 0;
                        })
                        .attr('width', function (d5) {
                            return 0;
                        })
                        .attr('y', function (d5) {
                            return y(0);
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d6) => {
                        return this.filtered.indexOf(d6.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d6) {
                            return x(d6.name);
                        })
                        .attr('y', function (d6) {
                            return y(d6.value);
                        })
                        .attr('height', function (d6) {
                            return height - y(d6.value);
                        })
                        .attr('width', (d6) => {
                            return x.bandwidth();
                        })
                        .attr('fill', function (d6) {
                            return color(d6.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d7) => {
                        if (!this.hasZoom) {
                            if (this.filtered.length) {
                                if (this.filtered.indexOf(d7) == -1) {
                                    return 1;
                                } else {
                                    return 0.4;
                                }
                            } else {
                                return 1;
                            }
                        } else {
                            if (this.filteredZoom.indexOf(d7) > -1) {
                                if (this.filtered.length) {
                                    if (this.filtered.indexOf(d7) == -1) {
                                        return 1;
                                    } else {
                                        return 0.4;
                                    }
                                } else {
                                    return 1;
                                }
                            } else {
                                return 0.4;
                            }
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartHor() {
            '';
            var d3 = this.$d3;

            let brushed = () => {
                this.hasZoom = true;
                let extent = d3.event.selection;
                var selected = null;
                if (extent) {
                    let domainSize = y2.domain().length;
                    selected = y2.domain().filter(function (d, index) {
                        let fim = y2(y2.domain()[index + 1]) - 0.05;
                        if (index < domainSize - 1) {
                            return extent[0] <= fim * height && y2(d) * height <= extent[1];
                        } else {
                            return extent[0] <= height && y2(d) * height <= extent[1];
                        }
                    });
                }

                var start;
                var end;

                if (extent && extent[0] != extent[1]) {
                    start = selected[0];
                    end = selected[selected.length - 1];
                    start = this.dataset[0].values.indexOf(
                        this.dataset[0].values.filter((v) => v.name == start)[0]
                    );
                    end =
                        this.dataset[0].values.indexOf(
                            this.dataset[0].values.filter((v) => v.name == end)[0]
                        ) + 1;
                } else {
                    start = 0;
                    end = this.dataset[0].values.length;
                }

                var updatedData = this.dataset[0].values.slice(start, end);

                if (selected) {
                    this.filtered = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) == -1);
                    this.filteredZoom = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) > -1);
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                } else {
                    this.filtered = [];
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                }

                update(updatedData);
                enter(updatedData);
                exit(updatedData);
                updateScale(updatedData);
            };

            let updateScale = function (data) {
                // var tickScale = d3
                //   .scalePow()
                //   .range([data.length / 10, 0])
                //   .domain([data.length, 0])
                //   .exponent(0.5);

                // var brushValue = brush.extent()[1] - brush.extent()[0];
                // if (brushValue === 0) {
                //   brushValue = width;
                // }

                // var tickValueMultiplier = Math.ceil(Math.abs(tickScale(brushValue)));
                // var filteredTickValues = data
                //   .filter(function(d, i) {
                //     return i % tickValueMultiplier === 0;
                //   })
                //   .map(function(d) {
                //     return d.date;
                //   });

                focus.select('.x.axis').call(xAxis);
                focus.select('.y.axis').call(yAxis);
            };

            let update = (data) => {
                this.data = data;
                y.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                x.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                var bars = focus.selectAll('.bar').data(data);
                bars.attr('height', function (d) {
                    return y.bandwidth();
                })
                    .attr('width', function (d, i) {
                        return x(d.value);
                    })
                    .attr('x', function (d) {
                        return 0;
                    })
                    .attr('y', function (d) {
                        return y(d.name);
                    })
                    .attr('fill', function (d) {
                        return color(d.name);
                    });
            };

            let exit = function (data) {
                var bars = focus.selectAll('.bar').data(data);
                bars.exit().remove();
            };

            let enter = (data) => {
                this.data = data;
                y.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                x.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                this.$d3
                    .selectAll('.selection')
                    .attr('width', '77px')
                    .attr('stroke', this.cores[0]);

                if (this.tooltipDiv) this.tooltipDiv.remove();

                this.tooltipDiv = this.$d3
                    .select('body')
                    .append('div')
                    .attr('class', 'chart-tooltip')
                    .style('opacity', 0);

                var bars = focus.selectAll('.bar').data(data);
                bars.enter()
                    .append('rect')
                    .classed('bar', true)
                    .attr('height', function (d) {
                        return y.bandwidth();
                    })
                    .attr('width', function (d, i) {
                        return x(d.value);
                    })
                    .attr('x', function (d) {
                        return 0;
                    })
                    .attr('y', function (d) {
                        return y(d.name);
                    })
                    .attr('fill', function (d) {
                        return color(d.name);
                    })
                    .on('mouseover', this.tooltipMouseoverEvt)
                    .on('mousemove', (d) => {
                        this.tooltipDiv
                            .style(
                                'left',
                                this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                            )
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        this.tooltipDiv.transition().duration(500).style('opacity', 0);
                    });
            };

            var margin = { left: 40, bottom: 40, right: 100, top: 40 },
                margin2 = {
                    left: this.$refs.chartContent.offsetWidth - 90,
                    bottom: 40,
                    right: 20,
                    top: 40,
                };
            var width = this.$refs.chartContent.offsetWidth - margin.left - margin.right;
            var width2 = this.$refs.chartContent.offsetWidth - margin2.left - margin2.right;
            var height = this.$refs.chartContent.offsetHeight - margin.top - margin.bottom;
            // var h = height - margin.top - margin.bottom;

            var y = this.$d3.scaleBand().padding(0.1),
                y2 = this.$d3.scaleBand().padding(0.1),
                x = this.$d3.scaleLinear().range([0, width]),
                x2 = this.$d3.scaleLinear().range([0, width2]);

            var color = this.$d3.scaleOrdinal(this.cores);

            var xAxis = this.$d3.axisBottom(x),
                yAxis = this.$d3.axisLeft(y).tickFormat([]),
                yAxis2 = this.$d3.axisLeft(y).tickFormat([]);

            // var rowgroup = this.dataset.map(function(d) {
            //   return d.name;
            // });
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            y.domain(colNames).range([0, height]);
            x.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);
            x2.domain(x.domain());
            y2.domain(y.domain());

            var brush = d3
                .brushY()
                .extent([
                    [0, 0],
                    [width, height],
                ])
                .on('brush', brushed)
                .on('start', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('width', '77px')
                        .attr('stroke', this.cores[0]);
                    brushed();
                })
                .on('end', () => {
                    let extent = d3.event.selection;
                    if (!extent) {
                        this.closeZoom();
                    }
                });

            var svg = this.$d3.select(this.$refs.svgcontent);

            var focus = svg
                .append('g')
                .attr('class', 'focus')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var context = svg
                .append('g')
                .attr('class', 'context')
                .attr('transform', 'translate(' + margin2.left + ',' + margin2.top + ')');

            focus
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis);

            focus.append('g').attr('class', 'y axis').call(yAxis);

            enter(this.dataset[0].values);
            updateScale(this.dataset[0].values);

            var subBars = context.selectAll('.subBar').data(this.dataset[0].values);

            subBars
                .enter()
                .append('rect')
                .classed('subBar', true)
                .attr('height', function (d) {
                    return y.bandwidth();
                })
                .attr('width', function (d, i) {
                    return x2(d.value);
                })
                .attr('x', function (d) {
                    return 0;
                })
                .attr('y', function (d) {
                    return y(d.name);
                })
                .attr('fill', function (d) {
                    return '#c6c6c6';
                });

            context
                .append('g')
                .attr('class', 'y axis')
                .attr('transform', 'translate(0,0)')
                .call(yAxis2);

            context
                .append('g')
                .attr('class', 'y brush')
                .call(brush)
                .selectAll('rect')
                .attr('y', -6)
                .attr('height', height)
                .attr('width', width2 + 7);

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    let filtered = [...this.filtered];
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) {
                            if (!this.hasZoom) {
                                this.filtered = [];
                            } else {
                                this.filtered = filtered;
                            }
                        }
                    }
                    // otherwise remove it:
                    else {
                        // if (!this.hasZoom) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // } else if (this.filteredZoom.indexOf(d) > -1) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // }
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    if (newKeys.length == 0) {
                        if (!this.hasZoom) {
                            color.domain().forEach((d8) => {
                                if (this.filtered.indexOf(d8) == -1 && d9) {
                                    newKeys.push(d8);
                                }
                            });
                        } else {
                            this.filteredZoom.forEach((d9) => {
                                if (this.filtered.indexOf(d9) == -1 && d9) {
                                    newKeys.push(d9);
                                }
                            });
                        }
                    }

                    y.domain(newKeys).range([0, height]);
                    x.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d10, key) => {
                                if (this.hasZoom) {
                                    if (this.filteredZoom.indexOf(d10.name) > -1) return d10.value;
                                } else {
                                    if (this.filtered.indexOf(d10.name) == -1) return d10.value;
                                }
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    // let d3 = this.$d3;

                    let bars = focus.selectAll('.bar').data(this.data);

                    bars.filter((d11) => {
                        return this.filtered.indexOf(d11.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d11) {
                            return 0;
                        })
                        .attr('width', function (d11) {
                            return 0;
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d12) => {
                        return this.filtered.indexOf(d12.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d12) {
                            return 0;
                        })
                        .attr('y', function (d12) {
                            return y(d12.name);
                        })
                        .attr('height', function (d12) {
                            return y.bandwidth();
                        })
                        .attr('width', (d12, i) => {
                            return x(d12.value);
                        })
                        .attr('fill', function (d12) {
                            return color(d12.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d13) => {
                        if (!this.hasZoom) {
                            if (this.filtered.length) {
                                if (this.filtered.indexOf(d13) == -1) {
                                    return 1;
                                } else {
                                    return 0.4;
                                }
                            } else {
                                return 1;
                            }
                        } else {
                            if (this.filteredZoom.indexOf(d13) > -1) {
                                if (this.filtered.length) {
                                    if (this.filtered.indexOf(d13) == -1) {
                                        return 1;
                                    } else {
                                        return 0.4;
                                    }
                                } else {
                                    return 1;
                                }
                            } else {
                                return 0.4;
                            }
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartAbc() {
            var d3 = this.$d3;

            let total = this.dataset[0].values.length;
            let numOfClientsA = Math.round((total * 20) / 100);
            let numOfClientsB = Math.round((total * 30) / 100);

            this.dataset[0].values.forEach((d, i) => {
                if (i < numOfClientsA) {
                    d.colorname = 'A';
                } else if (i < numOfClientsB + numOfClientsA) {
                    d.colorname = 'B';
                } else {
                    d.colorname = 'C';
                }
            });

            let brushed = () => {
                this.hasZoom = true;
                let extent = d3.event.selection;
                var selected = null;
                if (extent) {
                    let domainSize = x2.domain().length;
                    selected = x2.domain().filter(function (d, index) {
                        let fim = x2(x2.domain()[index + 1]) - 15;
                        if (index < domainSize - 1) {
                            return extent[0] <= fim && x2(d) <= extent[1];
                        } else {
                            return extent[0] <= width && x2(d) <= extent[1];
                        }
                    });
                }

                var start;
                var end;

                if (extent && extent[0] != extent[1]) {
                    start = selected[0];
                    end = selected[selected.length - 1];
                    start = this.dataset[0].values.indexOf(
                        this.dataset[0].values.filter((v) => v.name == start)[0]
                    );
                    end =
                        this.dataset[0].values.indexOf(
                            this.dataset[0].values.filter((v) => v.name == end)[0]
                        ) + 1;
                } else {
                    start = 0;
                    end = this.dataset[0].values.length;
                }

                var updatedData = this.dataset[0].values.slice(start, end);

                if (selected) {
                    this.filtered = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) == -1);
                    this.filteredZoom = this.dataset[0].values
                        .map((v) => v.name)
                        .filter((v) => selected.indexOf(v) > -1);
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                } else {
                    this.filtered = [];
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                }

                update(updatedData);
                enter(updatedData);
                exit(updatedData);
                updateScale(updatedData);
            };

            let updateScale = function (data) {
                var tickScale = d3
                    .scalePow()
                    .range([data.length / 10, 0])
                    .domain([data.length, 0])
                    .exponent(0.5);

                var brushValue = brush.extent()[1] - brush.extent()[0];
                if (brushValue === 0) {
                    brushValue = width;
                }

                var tickValueMultiplier = Math.ceil(Math.abs(tickScale(brushValue)));
                var filteredTickValues = data
                    .filter(function (d, i) {
                        return i % tickValueMultiplier === 0;
                    })
                    .map(function (d) {
                        return d.date;
                    });

                focus.select('.x.axis').call(xAxis.tickValues(filteredTickValues));
                focus.select('.y.axis').call(yAxis);
            };

            let update = (data) => {
                this.data = data;
                x.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                var bars = focus.selectAll('.bar').data(data);

                bars.attr('height', function (d) {
                    return height - y(d.value);
                })
                    .attr('width', function (d, i) {
                        return x.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x(d.name);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', function (d) {
                        color(d.name);
                        return colorGroup(d.colorname);
                    });
            };

            let exit = function (data) {
                var bars = focus.selectAll('.bar').data(data);
                bars.exit().remove();
            };

            let enter = (data) => {
                this.data = data;
                x.domain(
                    data.map(function (d) {
                        return d.name;
                    })
                );
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d.value;
                    }),
                ]);

                this.$d3
                    .selectAll('.selection')
                    .attr('height', '77px')
                    .attr('stroke', this.cores[0]);

                if (this.tooltipDiv) this.tooltipDiv.remove();

                this.tooltipDiv = this.$d3
                    .select('body')
                    .append('div')
                    .attr('class', 'chart-tooltip')
                    .style('opacity', 0);

                var bars = focus.selectAll('.bar').data(data);

                bars.enter()
                    .append('rect')
                    .classed('bar', true)
                    .attr('height', function (d) {
                        return height - y(d.value);
                    })
                    .attr('width', function (d) {
                        return x.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x(d.name);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', function (d) {
                        color(d.name);
                        return colorGroup(d.colorname);
                    })
                    .on('mouseover', this.tooltipMouseoverEvt)
                    .on('mousemove', (d) => {
                        this.tooltipDiv
                            .style(
                                'left',
                                this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                            )
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        this.tooltipDiv.transition().duration(500).style('opacity', 0);
                    });
            };

            var margin = { top: 10, right: 10, bottom: 120, left: 40 },
                margin2 = {
                    top: this.$refs.chartContent.offsetHeight - 90,
                    right: 10,
                    bottom: 40,
                    left: 40,
                };
            var width = this.$refs.chartContent.offsetWidth - margin.left - margin.right;
            var height = this.$refs.chartContent.offsetHeight - margin.top - margin.bottom;
            var height2 = this.$refs.chartContent.offsetHeight - margin2.top - margin2.bottom;
            // var h = height - margin.top - margin.bottom;

            var x = this.$d3.scaleBand().range([0, width]).padding(0.1),
                x2 = this.$d3.scaleBand().range([0, width]).padding(0.1),
                y = this.$d3.scaleLinear().range([height, 0]),
                y2 = this.$d3.scaleLinear().range([height2, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);
            var colorGroup = this.$d3.scaleOrdinal(this.cores2);

            var xAxis = this.$d3.axisBottom(x),
                xAxis2 = this.$d3.axisBottom(x).tickValues([]),
                yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            // var rowgroup = this.dataset.map(function(d) { return d.name; });
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            x.domain(colNames).range([0, width]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);
            x2.domain(x.domain());
            y2.domain(y.domain());

            var brush = d3
                .brushX()
                .extent([
                    [0, 0],
                    [width, height],
                ])
                .on('brush', brushed)
                .on('start', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('height', '77px')
                        .attr('stroke', this.cores[0]);
                    brushed();
                })
                .on('end', () => {
                    let extent = d3.event.selection;
                    if (!extent) {
                        this.closeZoom();
                    }
                });

            var svg = this.$d3.select(this.$refs.svgcontent);

            var focus = svg
                .append('g')
                .attr('class', 'focus')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var context = svg
                .append('g')
                .attr('class', 'context')
                .attr('transform', 'translate(' + margin2.left + ',' + margin2.top + ')');

            focus
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis);

            focus.append('g').attr('class', 'y axis').call(yAxis);

            enter(this.dataset[0].values);
            updateScale(this.dataset[0].values);

            var subBars = context.selectAll('.subBar').data(this.dataset[0].values);

            subBars
                .enter()
                .append('rect')
                .classed('subBar', true)
                .attr('height', function (d) {
                    return height2 - y2(d.value);
                })
                .attr('width', function (d, i) {
                    return x.bandwidth();
                })
                .attr('x', function (d) {
                    return x2(d.name);
                })
                .attr('y', function (d) {
                    return y2(d.value);
                })
                .attr('fill', function (d) {
                    return '#c6c6c6';
                });

            context
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height2 + ')')
                .call(xAxis2);

            context
                .append('g')
                .attr('class', 'x brush')
                .call(brush)
                .selectAll('rect')
                .attr('y', -6)
                .attr('height', height2 + 7 + 'px');

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    let filtered = [...this.filtered];
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) {
                            if (!this.hasZoom) {
                                this.filtered = [];
                            } else {
                                this.filtered = filtered;
                            }
                        }
                    }
                    // otherwise remove it:
                    else {
                        // if (!this.hasZoom) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // } else if (this.filteredZoom.indexOf(d) > -1) {
                        //   this.filtered.splice(this.filtered.indexOf(d), 1);
                        // }
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    if (newKeys.length == 0) {
                        if (!this.hasZoom) {
                            color.domain().forEach((d14) => {
                                if (this.filtered.indexOf(d14) == -1 && d14) {
                                    newKeys.push(d14);
                                }
                            });
                        } else {
                            this.filteredZoom.forEach((d15) => {
                                if (this.filtered.indexOf(d15) == -1 && d15) {
                                    newKeys.push(d15);
                                }
                            });
                        }
                    }

                    x.domain(newKeys).range([0, width]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d16, key) => {
                                if (this.hasZoom) {
                                    if (this.filteredZoom.indexOf(d16.name) > -1) return d16.value;
                                } else {
                                    if (this.filtered.indexOf(d16.name) == -1) return d16.value;
                                }
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    // let d3 = this.$d3;

                    let bars = focus.selectAll('.bar').data(this.data);

                    bars.filter((d17) => {
                        return this.filtered.indexOf(d17.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d17) {
                            return 0;
                        })
                        .attr('width', function (d17) {
                            return 0;
                        })
                        .attr('y', function (d17) {
                            return y(0);
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d18) => {
                        return this.filtered.indexOf(d18.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d18) {
                            return x(d18.name);
                        })
                        .attr('y', function (d18) {
                            return y(d18.value);
                        })
                        .attr('height', function (d18) {
                            return height - y(d18.value);
                        })
                        .attr('width', (d18) => {
                            return x.bandwidth();
                        })
                        .attr('fill', function (d18) {
                            color(d18.name);
                            return colorGroup(d18.colorname);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d19) => {
                        if (!this.hasZoom) {
                            if (this.filtered.length) {
                                if (this.filtered.indexOf(d19) == -1) {
                                    return 1;
                                } else {
                                    return 0.4;
                                }
                            } else {
                                return 1;
                            }
                        } else {
                            if (this.filteredZoom.indexOf(d19) > -1) {
                                if (this.filtered.length) {
                                    if (this.filtered.indexOf(d19) == -1) {
                                        return 1;
                                    } else {
                                        return 0.4;
                                    }
                                } else {
                                    return 1;
                                }
                            } else {
                                return 0.4;
                            }
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', (d, i) => {
                    if (i < numOfClientsA) {
                        return colorGroup('A');
                    } else if (i < numOfClientsB + numOfClientsA) {
                        return colorGroup('B');
                    } else {
                        return colorGroup('C');
                    }
                });

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartNoZoom() {
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            // let barPadding = 0.5;

            const svg = this.$d3.select(this.$refs.svgcontent);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x0 = this.$d3.scaleBand().padding(0.1);

            var x1 = this.$d3.scaleBand().padding(0.2);

            var y = this.$d3.scaleLinear().range([h, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);

            var xAxis = this.$d3.axisBottom(x0);

            var yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var rowgroup = this.dataset.map(function (d) {
                return d.row;
            });
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            x0.domain(rowgroup).range([0, w]);
            x1.domain(colNames).range([0, w]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(0,0)';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', x1.bandwidth())
                .attr('x', function (d) {
                    return x1(d.name);
                })
                .style('fill', (d, index) => color(d.name))
                .attr('y', function (d) {
                    return y(0);
                })
                .attr('height', function (d) {
                    return h - y(0);
                })
                .on('mouseover', this.tooltipMouseoverEvt)
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            slice
                .selectAll('rect')
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            slice
                .selectAll('rect')
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d20) => {
                        if (this.filtered.indexOf(d20) == -1 && d20) {
                            newKeys.push(d20);
                        }
                    });

                    x1.domain(newKeys).range([0, w]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d21, key) => {
                                if (this.filtered.indexOf(d21.name) == -1) return d21.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y')
                        .transition()
                        // .call(this.$d3.axisBottom(x).ticks(null, "s"))
                        .call(yAxis)
                        .duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    // let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d22) {
                        return d22.values;
                    });

                    bars.filter((d23) => {
                        return this.filtered.indexOf(d23.name) > -1;
                    })
                        .transition()
                        // .attr("x", function(d) {
                        //     return (+d3.select(this).attr("x")) + (+d3.select(this).attr("width"))/2;
                        // })
                        .attr('height', function (d23) {
                            return 0;
                        })
                        .attr('width', function (d23) {
                            return 0;
                        })
                        .attr('y', function (d23) {
                            return y(0);
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d24) => {
                        return this.filtered.indexOf(d24.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d24) {
                            return x1(d24.name);
                        })
                        .attr('y', function (d24) {
                            return y(d24.value);
                        })
                        .attr('height', function (d24) {
                            return h - y(d24.value);
                        })
                        .attr('width', (d24) => {
                            return x1.bandwidth();
                        })
                        .attr('fill', function (d24) {
                            return color(d24.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d25) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d25) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                // .attr("x", w - this.legendRectSize - this.legendSpacing)
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                // .attr("fill", color)
                // .attr("stroke", color)
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartHorNoZoom() {
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            // let barPadding = 0.5;

            const svg = this.$d3.select(this.$refs.svgcontent);
            var color = this.$d3.scaleOrdinal(this.cores);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x = this.$d3.scaleLinear().range([0, w]);

            var y0 = this.$d3.scaleBand().padding(0.1);

            var y1 = this.$d3.scaleBand().padding(0.2);

            var xAxis = this.$d3.axisBottom(x).tickFormat(this.customFormatter);

            var yAxis = this.$d3.axisLeft(y0);

            var div = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var colgroup = this.dataset.map(function (d) {
                return d.row;
            });
            var rowNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            y0.domain(colgroup).range([0, h]);
            y1.domain(rowNames).range([0, h]);
            x.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(0, 0)';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', function (d) {
                    return 0;
                })
                .attr('x', function (d) {
                    return 0;
                })
                .style('fill', (d, index) => /*this.cores[index] */ color(d.name))
                .attr('y', function (d) {
                    return y1(d.name);
                })
                .attr('height', y1.bandwidth())
                .on('mouseover', this.tooltipMouseoverEvt)
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            slice.selectAll('rect').attr('width', function (d) {
                return x(d.value);
            });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d28) => {
                        if (this.filtered.indexOf(d28) == -1 && d28) {
                            newKeys.push(d28);
                        }
                    });

                    y1.domain(newKeys).range([0, h]);
                    x.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d28, key) => {
                                if (this.filtered.indexOf(d28.name) == -1) return d28.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.x').transition().call(xAxis).duration(500);

                    // Filter out the bands that need to be hidden:
                    let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d28) {
                        return d28.values;
                    });

                    bars.filter((d28) => {
                        return this.filtered.indexOf(d28.name) > -1;
                    })
                        .transition()
                        .attr('x', function (d28) {
                            return 0;
                        })
                        .attr('height', function (d28) {
                            return 0;
                        })
                        .attr('width', function (d28) {
                            return 0;
                        })
                        .attr('y', function (d28) {
                            return +d3.select(this).attr('y') + +d3.select(this).attr('height') / 2;
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d28) => {
                        return this.filtered.indexOf(d28.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d28) {
                            return 0;
                        })
                        .attr('y', function (d28) {
                            return y1(d28.name);
                        })
                        .attr('height', y1.bandwidth())
                        .attr('width', function (d28) {
                            return x(d28.value);
                        })
                        .attr('fill', function (d28) {
                            return color(d28.key);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d28) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d28) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('p')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartAbcNoZoom() {
            let total = this.dataset[0].values.length;
            let numOfClientsA = Math.round((total * 20) / 100);
            let numOfClientsB = Math.round((total * 30) / 100);

            this.dataset[0].values.forEach((d, i) => {
                if (i < numOfClientsA) {
                    d.colorname = 'A';
                } else if (i < numOfClientsB + numOfClientsA) {
                    d.colorname = 'B';
                } else {
                    d.colorname = 'C';
                }
            });

            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            // let barPadding = 0.5;

            const svg = this.$d3.select(this.$refs.svgcontent);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x0 = this.$d3.scaleBand().padding(0.1);

            var x1 = this.$d3.scaleBand().padding(0.2);

            var y = this.$d3.scaleLinear().range([h, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);
            var colorGroup = this.$d3.scaleOrdinal(this.cores2);

            var xAxis = this.$d3.axisBottom(x0);

            var yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var rowgroup = this.dataset.map((d) => d.row);
            var colNames = this.dataset[0].values.map((d) => d.name);

            x0.domain(rowgroup).range([0, w]);
            x1.domain(colNames).range([0, w]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().duration(500).style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', (_) => 'translate(0,0)');

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', x1.bandwidth())
                .attr('x', function (d) {
                    return x1(d.name);
                })
                .style('fill', (d, index) => {
                    color(d.name);
                    return colorGroup(d.colorname);
                })
                .attr('y', function (d) {
                    return y(0);
                })
                .attr('height', function (d) {
                    return h - y(0);
                })
                .on('mouseover', this.tooltipMouseoverEvt)
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            slice
                .selectAll('rect')
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            slice
                .selectAll('rect')
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    // Update the array to filter the chart by:
                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }

                    // Update the scales for each group(/states)'s items:
                    var newKeys = [];
                    color.domain().forEach((d30) => {
                        if (this.filtered.indexOf(d30) == -1 && d30) {
                            newKeys.push(d30);
                        }
                    });

                    x1.domain(newKeys).range([0, w]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d30, key) => {
                                if (this.filtered.indexOf(d30.name) == -1) return d30.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    // Filter out the bands that need to be hidden:
                    // let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d30) {
                        return d30.values;
                    });

                    bars.filter((d30) => {
                        return this.filtered.indexOf(d30.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d30) {
                            return 0;
                        })
                        .attr('width', function (d30) {
                            return 0;
                        })
                        .attr('y', function (d30) {
                            return y(0);
                        })
                        .duration(500);

                    // Adjust the remaining bars:
                    bars.filter((d31) => {
                        return this.filtered.indexOf(d31.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d31) {
                            return x1(d31.name);
                        })
                        .attr('y', function (d31) {
                            return y(d31.value);
                        })
                        .attr('height', function (d31) {
                            return h - y(d31.value);
                        })
                        .attr('width', (d31) => {
                            return x1.bandwidth();
                        })
                        .attr('fill', function (d31) {
                            return color(d31.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d31) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d31) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', (d, i) => {
                    if (i < numOfClientsA) {
                        return colorGroup('A');
                    } else if (i < numOfClientsB + numOfClientsA) {
                        return colorGroup('B');
                    } else {
                        return colorGroup('C');
                    }
                });

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        hideData(d, i) {
            d.active = !d.active;
        },
        mountChart() {
            if (!this.noData) {
                setTimeout(() => {
                    if (this.zoomned) {
                        if (this.datacontent.direction == 'v') {
                            this.svgChart();
                        } else if (this.datacontent.direction == 'd') {
                            this.svgChartHor();
                        } else if (this.datacontent.direction == 'abc') {
                            this.svgChartAbc();
                        }
                    } else {
                        if (this.datacontent.direction == 'v') {
                            this.svgChartNoZoom();
                        } else if (this.datacontent.direction == 'd') {
                            this.svgChartHorNoZoom();
                        } else if (this.datacontent.direction == 'abc') {
                            this.svgChartAbcNoZoom();
                        }
                    }
                }, 10);
            }
        },
        redrawChart(clean = true) {
            if (clean) {
                this.cleanChart();
            }

            setTimeout(this.mountChart, 10);
        },
        cleanChart() {
            this.$d3.select(this.$refs.svgcontent).selectAll('g').remove();
            this.$d3.select(this.$refs.LGbox).selectAll('.legend-box').remove();

            if (this.tooltipDiv) {
                this.tooltipDiv.remove();
            }
        },
        /*  Este é o formatador que vai mostrar os números do eixo Y
        no gráfico. o "1,8k", "2,5M" e por aí vai. */
        customFormatter(number) {
            let p = this.formatter.formatToParts(number);

            let g = p.filter((e) => {
                return e.type == 'group';
            });

            if (g.length < 1) {
                return this.formatter.format(number);
            } else {
                let sufix = '';
                let value = '';

                if (p[0].value.length == 3) {
                    value = p[0].value;
                } else {
                    value = `${p[0].value}${
                        p[0].value.length < 2 ? this.$t('scale-separator') : ''
                    }${p[2].value.substring(0, 2 - p[0].value.length)}`;
                }

                switch (g.length) {
                    case 1:
                        sufix = 'k';
                        break;
                    case 2:
                        sufix = 'M';
                        break;
                    case 3:
                        sufix = 'B';
                        break;
                    case 4:
                        sufix = 'T';
                        break;
                }

                return `${value}${sufix}`;
            }
        },
        zoom() {
            this.zoomned = !this.zoomned;
            if (!this.zoomned) {
                this.hasZoom = false;
            }
            this.redrawChart();
        },
        closeZoom() {
            this.hasZoom = false;
            this.redrawChart();
        },
        /*  Handler de evento separado para o tooltip. Como ele é usado várias
        vezes durante o desenho do gráfico, foi colocado aqui para lidar uma vez só
        com o caso especial de mostrar a moeda no tooltip. */
        tooltipMouseoverEvt(d) {
            let temp = this.isCurrencyChart(this.datacontent.titulo) 
                ? this.getDecimal(d.value, null, true)
                : this.getDecimal(d.value, 0, false)

            let msg = `<b>${d.name}:</b> ${temp}`;

            // .transition()
            this.tooltipDiv
                .html(msg)
                .transition()
                .duration(500)
                .style('opacity', this.legendOpacity)
                .style('color', '#FFF')
                .style('left', this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px')
                .style('top', this.$d3.event.pageY - 40 + 'px');
        },
    },
};
</script>

<style lang="scss">
.axis {
    @include defaultFont();
    font-weight: 600;
    color: $darker-gray-color;
}

.legend-box > :not(.legend-color-box) {
    color: $darker-gray-color;
}
</style>
